import React, { useState } from "react";
import styled from "@emotion/styled";
import { SideMenu } from "./SideMenu";
import { Logo } from "./Logo";
import { Tagline } from "./Tagline";
import { MenuItems } from "./MenuItems";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { ChatWithUs } from "./ChatWithUs";
import { GoogleReviewsBadge } from "./GoogleReviewsBadge";

const Nav = styled.div`
    display: flex;
`;

const NavbarContainer = styled.div`
    position:relative;
    width:100%;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5em;
`;

const NavbarLogo = styled.img`
    height: 35px; 
    width: auto;
`;

const reviewKeyWords = {
    'fr' : 'avis-client',
    'en' : 'reviews',
    'nl' : 'reviews',
    'de' : 'bewertungen',
    'ru' : 'reviews'
};

const blogUrls = {
    'en' : 'https://www.clubvillamar.com/blog',
    'de' : 'https://www.clubvillamar.de/blog',
    'nl' : 'https://www.clubvillamar.nl/blog',
    'es' : 'https://www.clubvillamar.es/blog',
    'ru' : 'https://www.clubvillamar.ru/blog',
    'fr' : 'https://www.clubvillamar.fr/blog',
    'it' : 'https://www.clubvillamar.com/blog',
    'da' : 'https://www.clubvillamar.com/blog',
    'no' : 'https://www.clubvillamar.com/blog',
    'ca_es' : 'https://www.clubvillamar.com/blog',
}

class NavbarComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    menuList = () => {
        const { t, r, locale, renderContext, parameterContext } = this.props;
        const hostForRoute = renderContext.scheme + '://' + parameterContext.inverse_domain_locales[locale] + (( renderContext.port != 80 && renderContext.port != 443) ? ':' + renderContext.port : '');
        return [
            {
                label: t('home'),
                url: hostForRoute + r('homepage')
            },
            {
                label:t('about_spain'),
                skip: ['no','da','it','ca_es'].includes(locale) ? true : false,
                url :  hostForRoute + r('landing', {'uri': (locale === 'ru' ? 'spain' : t('spain').toLowerCase() ) + '/' })
            },
            {
                label:t('populardestinations'),
                url: null,
                skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                children: [
                    {
                        label: t('villas_footer') + ' ' + t('spain'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_country', {'country': t('spain').toLowerCase()}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('costabrava'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_region', {'country': t('spain').toLowerCase(), 'region': 'costa-brava'}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('costablanca'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_region', {'country': t('spain').toLowerCase(), 'region': 'costa-blanca'}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('lloretdemar'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'lloret-de-mar'}),
                    },
                    {
                        label: t('villas_footer') + ' ' +  t('tossademar'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'tossa-de-mar'}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('l_escala'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'l-escala'}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('blanes'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'blanes'}),
                    },
                    {
                        label: t('villas_footer') + ' ' + t('moraira'),
                        skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                        url: hostForRoute + r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-blanca', 'city': 'moraira'}),
                    },
                ]
            },
            {
                label:t('type_of_villa'),
                url: null,
                skip: ['es','it','ca_es','no','da','ru'].includes(locale) ? true : false,
                children: [
                    {
                        label: t('villas_with_extra_privacy') ,
                        skip: false,
                        url: hostForRoute + r('search', { query: 'poolWithPrivacy/1/poolType/private' }),
                    },
                    {
                        label: t('large_villas_for_families'),
                        skip: false,
                        url: hostForRoute + r('search', { query: 'numBedrooms/4' }),
                    },
                    {
                        label: t('pet_friendly_villas'),
                        skip: false,
                        url: hostForRoute + r('search', { query: 'petsAllowed/1' }),
                    },
                    {
                        label: t('villas_for_youngsters'),
                        skip: false,
                        url: hostForRoute + r('search', { query: 'youngstersAllowed/1' }),
                    },
                    {
                        label: t('villas_close_to_the_beach'),
                        skip: false,
                        url: hostForRoute + r('search', { query: 'distanceBeach/3' }),
                    }
                ]
            },
            {
                label: ['en','de','es','it','ca_es','no','da','ru'].includes(locale) ? t('contactus') : t('contact'),
                url :  hostForRoute + r("content_contact")
            },
            {
                label:t('aboutus'),
                url : hostForRoute + r("content_aboutus")
            },
            {
                label:t('faq_short'),
                url : hostForRoute + r("content_faq")
            },
            // {
            //     label:t('testimonials'),
            //     skip: ['no','da','it','ca_es'].includes(locale) ? true : false,
            //     url : hostForRoute + r("landing", { uri: reviewKeyWords[locale] + '/' })
            // },
            {
                label:t('blog'),
                skip: ['no','da','it','ca_es'].includes(locale) ? true : false,
                url : blogUrls[locale]
            }
        ]
    }

    render() {
        const menuList = this.menuList();

        return (
            <div>
                {!this.props.mobile && !this.props.tablet ?
                <Nav className="width-100 bg-grey3 px-4 bor-t-thin bor-b-thin bor-grey1 bor-solid">
                    <MenuItems mobile={false} menuList={menuList} />
                </Nav>
                :
                <NavbarContainer className="bg-white">
                    <Logo 
                        className="flex"
                        link={this.props.r('homepage')}
                        searchURLBase={this.props.searchURLBase}
                      />
                    {!this.props.mobile ? <Tagline mobile={true} className="blue1 font-80 text-center flex-3 "/> : ''}
                    {(
                      <div className="relative flex justify-fend items-center">
                            { this.props.chatWithUsLabel !== 'livechat_offline' &&
                                <ChatWithUs
                                    height="30"
                                    width="40"
                                    iconColor="green3"
                                    label={''}
                                    searchURLBase={this.props.searchURLBase}
                                    className="blue1 mr-4"
                                    mobile={this.props.mobile}
                                />
                            }
                          <SideMenu
                                isOpen={false}
                                mobile={true}
                                landingPagesIntl={this.props.landingPagesIntl}
                                aiLandingpagesIntl={this.props.aiLandingpagesIntl}
                                languageSelectorOptions={this.props.languageSelectorOptions}
                                sideMenuCallbackOpenCallback={this.props.sideMenuCallbackOpenCallback}
                                sideMenuCallbackClosedCallback={this.props.sideMenuCallbackClosedCallback}   
                                mobileDisplayPhonenumber={this.props.parameterContext.mobile_display_phonenumber}
                                currency={this.props.currency}
                                menuList={menuList}
                                locale={this.props.locale}
                                searchURLBase={this.props.searchURLBase}        
                          />
                      </div>
                   )}
                </NavbarContainer>
                }
                {this.props.mobile || this.props.tablet ? <GoogleReviewsBadge  rating={4.8} {...this.props} /> : ''}
            </div>
        );
    }
}
export const Navbar = compose(
    withFosRouter,
    withTranslator
)(NavbarComponent);

//{
//            label: t('destinations'),
//            url : false,
//            children: [
//                {
//                    label: t('spain'),
//                    url : hostForRoute + r('show_country', {country: t('spain').toLowerCase()})
//                },
//                {
//                    label:t('italy'),
//                    url : hostForRoute + r('show_country', {country: t('italy').toLowerCase()})
//                },
//                {
//                    label:t('france'),
//                    url : hostForRoute + r('show_country', {country: t('france').toLowerCase()})
//                },
//                {
//                    label:t('croatia'),
//                    url : hostForRoute + r('show_country', {country: t('croatia').toLowerCase()})
//                },
//                {
//                    label:t('portugal'),
//                    url : hostForRoute + r('show_country', {country: t('portugal').toLowerCase()})
//                }
//            ]
//        },